module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "title": "优惠券",
      "backFn": "true"
    },
    on: {
      "back": _vm.back
    }
  }), _vm._v(" "), _c('tab', {
    staticClass: "tab",
    attrs: {
      "line-width": 2,
      "active-color": "#fc378c"
    },
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, _vm._l((_vm.tabList), function(item, index) {
    return _c('tab-item', {
      key: index,
      staticClass: "vux-center",
      attrs: {
        "selected": _vm.tabIndex == index
      },
      on: {
        "on-item-click": _vm.tabTap
      }
    }, [_vm._v(_vm._s(item))])
  })), _vm._v(" "), _c('view-box', {
    staticClass: "collectBox",
    attrs: {
      "body-padding-bottom": "0"
    }
  }, [_vm._l((_vm.couponList), function(item, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "to": {
          name: 'couponDetail',
          params: {
            id: item._id
          }
        }
      }
    }, [_c('div', {
      staticClass: "list  tab-swiper vux-center",
      attrs: {
        "tag": "div"
      }
    }, [_c('div', {
      staticClass: "box1 flex vux-1px-b"
    }, [(item.thumbnail) ? _c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": _vm.UPLOAD_DOMAIN + item.thumbnail + '?x-oss-process=image/resize,w_120',
        "default-src": "static/placeholder.png",
        "container": ".collectBox"
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "flex-1 text-l"
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.type == 'free') ? _c('p', [_c('b', [_vm._v("免费兑换券")])]) : _vm._e(), _vm._v(" "), (item.type == 'cash-off') ? _c('p', [_c('b', [_vm._v("满￥" + _vm._s(_vm._f("fen2yuan")(item.cashOffLimit)) + "减￥" + _vm._s(_vm._f("fen2yuan")(item.cashOffValue)))])]) : _vm._e(), _vm._v(" "), (item.type == 'rate-off') ? _c('p', [_c('b', [_vm._v("满" + _vm._s(item.rateOffLimit) + "件打" + _vm._s(item.rateOffValue) + "折")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "coupon-date"
    }, [_vm._v("有效期至：" + _vm._s(_vm._f("date")(item.expirationDate)))])]), _vm._v(" "), _c('div', {
      staticClass: "collect-tap"
    }, [(item.order) ? _c('span', [_vm._v("已使用")]) : (_vm.couponExpired(item)) ? _c('span', [_vm._v("已过期")]) : _c('span', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v("未使用")])])])])])
  }), _vm._v(" "), (_vm.couponList.length == 0) ? _c('not-data', {
    attrs: {
      "imgPic": "collect"
    }
  }) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8ca7ce2"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/couponList/couponList.vue
// module id = 622
// module chunks = 0